// extracted by mini-css-extract-plugin
export var printerCard = "_8y-1";
export var printerCardConfigured = "_8y-2";
export var printerCardError = "_8y-3";
export var printerCardsContainer = "_8y-0";
export var printerIcon = "_8y-8";
export var printerIconConfigured = "_8y-5";
export var printerIconContainer = "_8y-4";
export var printerIconError = "_8y-6";
export var printerIconUnconfigured = "_8y-7";